import { useParams, useSearchParams } from 'react-router-dom';

import { RunTypeIcon } from '@/components/RunTypeIcon';

import { Breadcrumb } from '../../components/Breadcrumbs';
import { appPublicPath, appRunPath } from '../../utils/constants';
import { useRootRunAndRun } from '../Run/utils/useRootRunAndRun';

export function PublicRunCrumb() {
  const { shareToken, runId } = useParams();
  const [searchParams] = useSearchParams();
  const traceId = searchParams.get('trace_id') ?? undefined;
  const { rootRun, run } = useRootRunAndRun(traceId, runId, {
    runShareToken: shareToken,
  });
  const hasEllipsis =
    runId &&
    run?.data?.parent_run_id &&
    run?.data?.parent_run_id !== rootRun?.id;

  const runList = [rootRun ?? undefined, hasEllipsis ? null : undefined];
  if (runId && rootRun?.id !== runId && run.data) {
    runList.push(run.data);
  }

  const searchParamsString = new URLSearchParams({
    ...(rootRun?.trace_id && rootRun?.trace_id === rootRun?.id
      ? { trace_id: rootRun.trace_id }
      : {}),
    ...(rootRun?.start_time ? { start_time: rootRun?.start_time } : {}),
  }).toString();

  return runList.map((runOrEllipsis, idx) => {
    if (runOrEllipsis === undefined) {
      return null;
    }
    if (runOrEllipsis === null) {
      return <Breadcrumb key="ellipsis" path="#" name="..." />;
    }
    const { id, name, run_type } = runOrEllipsis;

    return (
      <Breadcrumb
        key={id}
        isFirst={idx === 0}
        path={`/${appPublicPath}/${shareToken}/${appRunPath}/${runOrEllipsis.id}?${searchParamsString}`}
        icon={<RunTypeIcon className="h-5 w-5" run={{ name, run_type }} />}
        name={name}
        isActive={id === runId || (runId == null && id === rootRun?.id)}
      />
    );
  });
}
